jQuery(function ($) {
  var wrap_table = $(".page-main--wrapper table");
  if (wrap_table.length) {
    wrap_table.wrap("<div class='wrap-table'></div>");
  }
  $('.contact-form').submit(function (e) {
    var emailField = $(this).find('input[type="email"]:first');
    console.log(emailField.val());
    var errorMsg = '<label class="error-msg" for="' + emailField.attr('id') + '">Please enter a valid email.</label>';

    if (!validEmail(emailField.val()) === true) {
      if (emailField.parent().is('li')) {
        emailField.parent().addClass('has-error').find('.error-msg').remove();
        $('#email').after(errorMsg);
      } else {
        $(this).addClass('has-error').find('.error-msg').remove();
        $(this).append(errorMsg);
      }
      e.preventDefault();
    }

  });

  /* Highlight Menu */
  // Get current page URL
  var url = window.location.href;
  // remove # from URL
  url = url.substring(0, (url.indexOf("#") == -1) ? url.length : url.indexOf("#"));
  // remove parameters from URL
  url = url.substring(0, (url.indexOf("?") == -1) ? url.length : url.indexOf("?"));
  //remove https://
  url = url.replace(/(^\w+:|^)\/\//, '');
  // select file name
  url = url.substr(url.indexOf("/"));

  // Loop all menu items
  $('.site-nav  li').each(function () {
    var href = $(this).find('a').attr('href');
    // Check filename
    if (url == href) {
      var parentClass = $(this).parent('ul').attr('class');
      if (parentClass == 'site-nav__dropdown') {
        $(this).parents('.site-nav li').addClass('current');
      }
    }
  });

  /* End Highlight Menu */

  /* Hidden controls video */
  var vids = $(".homepage-video video");
  $.each(vids, function () {
    this.controls = false;
  });



  /* End Hidden controls video */


  $('#create_customer').submit(function (e) {
    var firstNameField = $(this).find('#FirstName');
    var lastNameField = $(this).find('#LastName');
    var emailField = $(this).find('#customerEmail');
    var pwField = $(this).find('#CreatePassword');

    if (firstNameField.val() == "") {
      firstNameField.addClass('has-error');
      e.preventDefault();
    }
    if (lastNameField.val() == "") {
      lastNameField.addClass('has-error');
      e.preventDefault();
    }
    if (emailField.val() == "") {
      emailField.addClass('has-error');
      e.preventDefault();
    }
    if (pwField.val() == "") {
      pwField.addClass('has-error');
      e.preventDefault();
    }
  });

  function validEmail(value) {
    return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);
  }


  // jQuery.getJSON('/products/loose-leaf-tea-1.js', function(product) {
  //   //console.log(product);
  // } );


  $('.site-header__cart-toggle').on('mouseover', function () {
    $(this).parents('.site-header').addClass('cart-hover');
    iebarcartPopupScroll();

  });
  $('.js-drawer-close').click(function (event) {
    $('.site-header').removeClass('cart-hover');
  });
  if ($('.template-product .shopify-section .layout-teabar').length > 0) {
    $('body').addClass('product-teabar');
  }

  window.addEventListener('click', function (e) {
    if (document.getElementById('CartDrawer').contains(e.target)) {
      // Clicked in box
    } else {
      $('.site-header').removeClass('cart-hover');
    }
  });
  $('div').on('focusout', function () {
    $(this).removeClass('active');
  });


  $('.additemtocart').click(function (event) {
    $('.site-header .top-links--icon-links .site-header__cart-toggle .site-header__cart-indicator').addClass('hide');
    var form_id = $(this).attr('name');
    $(this).addClass('adding');
    //$('.site-header .top-links--icon-links .site-header__cart-toggle').addClass('loading');

    if (!localStorage.productCollections) {
      localStorage.productCollections = JSON.stringify({});
    }

    var productCollectionsData = JSON.parse(localStorage.productCollections);
    productCollectionsData[form_id] = $(this).closest('.grid__item').find('.product-grid--collection').text();
    localStorage.productCollections = JSON.stringify(productCollectionsData);

    addItem(form_id);
  });

  $('.template-product #AddToCart').click(function (event) {
    $('.site-header .top-links--icon-links .site-header__cart-toggle .site-header__cart-indicator').addClass('hide');
    $('.site-header .top-links--icon-links .site-header__cart-toggle').addClass('has-cart loading');
    $('.site-header .top-links--icon-links').addClass('has-cart addtocart-pdp');

    var form_id = $(this).attr('proid');
    console.log($(this).closest('.grid__item').find('.collection-title').text());
    if (!localStorage.productCollections) {
      localStorage.productCollections = JSON.stringify({});
    }
    var productCollectionsData = JSON.parse(localStorage.productCollections);
    productCollectionsData[form_id] = $(this).closest('.grid__item').find('.collection-title').text();
    localStorage.productCollections = JSON.stringify(productCollectionsData);

  });

  function addItem(form_id) {
    $('.site-header .top-links--icon-links .site-header__cart-toggle .site-header__cart-indicator').addClass('hide');
    $('.site-header .top-links--icon-links .site-header__cart-toggle').addClass('has-cart loading');
    $('.site-header .top-links--icon-links').addClass('has-cart');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $('#' + form_id).serialize(),
      success: addToCartOk,
      error: addToCartFail
    });
  }

  function addToCartOk(product) {

    console.log(product);
    ajaxCart.load();
    $('.additemtocart').removeClass('adding');
    setTimeout(function () {
      $('.site-header .top-links--icon-links .site-header__cart-toggle').removeClass('loading');
      $('.site-header .top-links--icon-links .site-header__cart-toggle .site-header__cart-indicator').removeClass('hide');
      $('.site-header').addClass('cart-hover');
      iebarcartPopupScroll();
    }, 1000);
  }

  function addToCartFail(obj, status) {
    $('.additemtocart').removeClass('adding');
    $('.site-header .top-links--icon-links .site-header__cart-toggle').removeClass('loading');
    $('.site-header .top-links--icon-links .site-header__cart-toggle .site-header__cart-indicator').removeClass('hide');
  }

  $('.videoembed .buttonplay').click(function (event) {
    var idvideo = $(this).parent().find('video').attr('id');
    console.log(idvideo);
    if (typeof idvideo != 'undefined' && idvideo != '') {
      var vid = document.getElementById("product-video");
      if ($(this).hasClass('play')) {
        vid.pause();
        $(this).removeClass('play');
      } else {
        vid.play();
        vid.controls = true;
        $(this).addClass('play');
      }

    }

  });

  function getScrollBarWidth() {
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return (w1 - w2);
  }

  //
  // $('#button-lightbox, .product-single .product-single__photos .product-single__photo-wrapper').click(function (event) {
  //   var imghtml = $('.product-single__photos').html();
  //   $('#images-lightbox-content .images-lightbox--content-popup').html(imghtml);
  //   var leftheader = $('.site-header .wrapper').offset().left;
  //   $('.site-header .wrapper').css({ 'margin-left': leftheader + 'px' });
  //   $('body').addClass('hiddenscoll');
  //   $('body').css({
  //     'overflow': 'hidden',
  //     'padding-right': getScrollBarWidth() + 'px'
  //   });
  //   $('#images-lightbox-content').addClass('showpopup').fadeIn();
  // });

  $('.images-lightbox--content-box .ic-close-black').click(function (event) {
    $('#images-lightbox-content .images-lightbox--content-popup').html('');

    $('body').removeClass('hiddenscoll');
    $('body').css({
      'overflow': 'auto',
      'padding-right': '0'
    });
    setTimeout(function () {
      $('.site-header .wrapper').css({ 'margin-left': 'auto' });
    }, 1000);

    $('#images-lightbox-content').removeClass('showpopup').fadeOut();
  });

  function iePopupScroll() {
    if ($(window).width() <= 767) return false;
    if (navigator.userAgent.indexOf('Trident/') < 0) return false;

    var currentTop = 0;
    if ($('#images-lightbox-content').length) {

      document.getElementById('images-lightbox-content').addEventListener('wheel', function (e) {
        if (e.deltaY < 0) {
          // up
          currentTop -= 50;
        } else if (e.deltaY > 0) {
          // down
          currentTop += 50;
        }

        currentTop = currentTop < 0 ? 0 : currentTop;

        $(this).scrollTop(currentTop);
      });

      $('.images-lightbox--content').on('scroll', function () {
        currentTop = $(this).scrollTop();
      });

    }

  }

  iePopupScroll();

  //iebarcartPopupScroll();

  function iebarcartPopupScroll() {
    if ($(window).width() <= 767) return false;
    if (!$('.site-header').hasClass('cart-hover')) return false;
    if (navigator.userAgent.indexOf('Trident/') < 0) return false;


    var currentTop2 = 0;
    if ($('#id_ajaxcart__inner').length) {
      document.getElementById('id_ajaxcart__inner').addEventListener('wheel', function (e) {
        if (e.deltaY < 0) {
          // up
          currentTop2 -= 50;
        } else if (e.deltaY > 0) {
          // down
          currentTop2 += 50;
        }

        currentTop2 = currentTop2 < 0 ? 0 : currentTop2;
        $(this).scrollTop(currentTop2);
        //scrollLock = true ; 
        $('#id_ajaxcart__inner').on('scroll', function () {
          currentTop2 = $(this).scrollTop();
        });


        if (e.preventDefault)
          e.preventDefault();
        e.returnValue = false;

      });

    } else {

    }

  }


  function showcollection() {
    $('.ajaxcart__product .grid__item .ajaxcart__product-collection').each(function (index) {
      //console.log($(this).attr('dataid'));
      var dataid = $(this).attr('dataid');
      if (dataid) {
        getcollecFunction($(this), dataid);
      }
    });
  }
  function getcollecFunction(item, productid) {
    var collectionname = '';
    var urlajaxcllec = '/admin/custom_collections.json?product_id=' + productid;

    $.getJSON(urlajaxcllec).done(function (collectsitems) {
      $.each(collectsitems, function (keycollec, valuecollec) {
        if (valuecollec) {
          $.each(valuecollec, function (keycollecitem, valuecollecitem) {
            if (valuecollecitem) {
              if (valuecollecitem.title != 'Feature Products - Homepage' && valuecollecitem.title != '') {
                collectionname = valuecollecitem.title;
                item.html(collectionname);
                return false;
                // console.log(collectionname);
              }
            }
          });
        }
      });
    });
  }



  $(window).load(function () {
    ajaxCart.load();
  });

  /*FAQ block toggle item*/

  $('.faq-block-item .faq-title').click(function () {
    $(this).toggleClass('minus');
    $(this).next().slideToggle(500).siblings('.faq_answer_container').slideUp();
  });
});

/* Image Hand move right to left */
$(window).scroll(function () {
  var $_object = $('.image-hand img');
  if ($_object.length > 0) {
    var hT = $_object.offset().top;
    var hH = $_object.outerHeight();
    var wH = $(window).height();
    var wS = $(this).scrollTop();
    if (wS > (hT + hH - wH - 350)) {
      $_object.addClass('moved');
    }
  }
});

/*Smooth scroll */
$('a.product-detail--url').click(function () {
  $('html, body').animate({
    scrollTop: $($(this).attr('href')).offset().top
  }, 500);
  return false;
});

/*Fade in out list background image*/
$(window).load(function () {

  $('.site-loading-img').fadeOut(500);

  var InfiniteRotator =
  {
    init: function () {
      //initial fade-in time (in milliseconds)
      var initialFadeIn = 1000;

      //interval between items (in milliseconds)
      var itemInterval = 10000;

      //cross-fade time (in milliseconds)
      var fadeTime = 10000;

      //count number of items
      var numberOfItems = $('.bg').length;

      //set current item
      var currentItem = 0;

      $('.bg').eq(currentItem).fadeOut(fadeTime);

      if (currentItem == numberOfItems - 1) {
        currentItem = 0;
      } else {
        currentItem++;
      }
      $('.bg').eq(currentItem).fadeIn(fadeTime);


      //show first item
      //$('.bg').eq(currentItem).css({ 'display': 'block' });
      $('.bg').eq(currentItem).fadeIn(initialFadeIn);

      //loop through the items
      var infiniteLoop = setInterval(function () {
        $('.bg').eq(currentItem).fadeOut(fadeTime);

        if (currentItem == numberOfItems - 1) {
          currentItem = 0;
        } else {
          currentItem++;
        }
        $('.bg').eq(currentItem).fadeIn(fadeTime);

      }, itemInterval);
    }
  };

  // InfiniteRotator.init();

});